import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ItemForm from 'components/Item/Form'
import Layout from 'components/Layout'
import BulkForm from 'components/Item/Form/BulkForm'
import Loader from 'components/Loader'

import { getIsItemsLoading } from 'store/Items/selector'
import { getIsPriceLevelsLoading } from 'store/PriceLevels/selectors'

const ItemDetails = () => {
  const isLoadingItems = useSelector(getIsItemsLoading)
  const isLoadingPriceLevels = useSelector(getIsPriceLevelsLoading)
  const location = useLocation()

  const currentPath = location.pathname
  const isNewItemCreation = currentPath === '/item/new'
  const isBulkEdit = currentPath === '/items/bulk'
  const isEditItem = !isNewItemCreation && !isBulkEdit
  const isLoading = isLoadingItems || isLoadingPriceLevels

  const setLayoutTitle = useMemo(() => {
    if (isNewItemCreation) return 'New Item'
    if (isBulkEdit) return 'Bulk Edit'
    if (isEditItem) return 'Edit Item'
  }, [isNewItemCreation, isBulkEdit, isEditItem])

  if (isLoading) {
    return <Loader />
  }
  return (
    <Layout
      backTo="/items"
      iconType="back"
      isSidebar
      title={setLayoutTitle}
      mainContent={isBulkEdit ? <BulkForm /> : <ItemForm />}
    />
  )
}

export default ItemDetails
